export enum VariantCreationMode {
    DYNAMIC = 'dynamic',
    NO_VARIANT = 'no_variant'
}
